import ExpiryBookingCheck from './expiry_booking_check';

export default ExpiryBookingCheck;
